import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils.service';
import { DataService } from 'src/app/shared/data.service';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-invite-manufacturer',
    templateUrl: './invite-manufacturer.component.html',
    styleUrls: ['./invite-manufacturer.component.scss'],
    standalone: false
})
export class InviteManufacturerComponent implements OnInit {
  inviteManufacturerForm!: FormGroup;

  constructor(private utils: UtilsService,
              private dataService: DataService,
              public dialogRef: MatDialogRef<InviteManufacturerComponent>,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.inviteManufacturerForm = new FormGroup({
      name: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
      phone_number: new FormControl(null, [Validators.required, Validators.minLength(7), Validators.maxLength(14)]),
      email: new FormControl(null, [Validators.required, Validators.email, this.utils.isValidEmail.bind(this)])
    });
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  closeDialog() {
    if (this.inviteManufacturerForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit() {
    console.log("valid? ", this.inviteManufacturerForm.valid)
    console.log("errors: ", this.inviteManufacturerForm.errors)
    if (this.inviteManufacturerForm.valid) {
        const payload = {
          name: this.inviteManufacturerForm.get('name')?.value,
          email: this.inviteManufacturerForm.get('email')?.value,
          phone: (this.inviteManufacturerForm.get('phone_number')?.value || '').replace(/\s+/g, ''),
        };
        console.log("payload: ", payload)
        this.dataService.post('ManufacturerInvitation/SendManufacturerInvitation', payload).then((data: any) => {
          if (data.statusCode === 200) {
            this.dialogRef.close(payload);
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Success',
                type: 'Success',
                message: 'Invitation sent successfully',
                buttonText: 'Ok'
              }
            });
          } else if (data.statusCode === 622) {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Warning',
                type: 'Warn',
                message: 'Invitation already sent!',
                buttonText: 'Ok',
                closeDialogRef: true
              }
            });
          }  else {
            const dialogRef = this.dialog.open(AlertDialogComponent, {
              disableClose: true,
              width: '400px',
              data: {
                title: 'Error',
                type: 'Error',
                message: 'Something went wrong, Please try again!',
                buttonText: 'Ok'
              }
            });
          }
        });
    } else {
      console.log("mark all")
      this.inviteManufacturerForm.markAllAsTouched();
    }
  }

}
